import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const AboutUsPage = () => {
  return (
    <div>
      <Helmet>
        <title>About Us | Dhanam Information System</title>
      </Helmet>

      <NavBar />

      {/* Hero Section */}
      <section className="about-hero text-white text-center py-5">
        <Container>
          <h1 className="fw-bold mb-3">About Dhanam Information System</h1>
          <p className="lead">
            Delivering digital excellence with innovation, precision, and
            purpose.
          </p>
        </Container>
      </section>

      {/* Mission & Vision */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <img
                src="https://dam-cdn.atl.orangelogic.com/AssetLink/304m8j2i56b5gd7s17a7u8sp6uucjaa0/fl_keep_metadata/Visibility.svg"
                alt="Our Vision"
                className="img-fluid rounded-4"
              />
            </Col>
            <Col md={6}>
              <h2 className="fw-bold mb-3" style={{ color: "rgb(11, 22, 63)" }}>
                Our Vision & Mission
              </h2>
              <p className="text-muted">
                Our vision is to empower global businesses with transformative
                technology that fuels growth and innovation. Our mission is to
                build reliable, scalable, and intelligent systems that help our
                clients stay competitive and future-ready.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Core Values */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold" style={{ color: "rgb(11, 22, 63)" }}>
              Our Core Values
            </h2>
          </div>
          <Row className="text-center">
            {[
              "Innovation",
              "Integrity",
              "Customer Success",
              "Teamwork",
              "Quality",
            ].map((value, idx) => (
              <Col md={4} className="mb-4" key={idx}>
                <div className="p-4 border rounded-4 shadow-sm h-100">
                  <i className="fa-solid fa-star mb-3 fs-2 text-warning"></i>
                  <h5 className="fw-bold">{value}</h5>
                  <p className="text-muted">
                    {value === "Innovation" &&
                      "We continuously evolve by embracing new ideas."}
                    {value === "Integrity" &&
                      "We commit to transparency, honesty, and ethics."}
                    {value === "Customer Success" &&
                      "We succeed when our customers thrive."}
                    {value === "Teamwork" &&
                      "Collaboration drives our best outcomes."}
                    {value === "Quality" &&
                      "We strive for excellence in every line of code."}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Company Journey */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h2 className="fw-bold mb-3" style={{ color: "rgb(11, 22, 63)" }}>
                Our Journey
              </h2>
              <p className="text-muted">
                From humble beginnings, Dhanam Information System has grown into
                a global force in IT services. With each milestone, we’ve built
                trust, transformed businesses, and contributed to meaningful
                progress in technology.
              </p>
              <ul>
                <li>✅ Founded in 2016</li>
                <li>✅ Served 100+ clients across 15 countries</li>
                <li>✅ 50+ enterprise projects successfully delivered</li>
              </ul>
            </Col>
            <Col md={6}>
              <img
                src="https://dam-cdn.atl.orangelogic.com/AssetLink/2m0y4sg157lnutd535445k1u7068regp/fl_keep_metadata/Alignment.svg"
                alt="Journey"
                className="img-fluid rounded-4"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us */}
      <section
        className="py-5 text-white"
        style={{ backgroundColor: "rgb(11, 22, 63)" }}
      >
        <Container>
          <h2 className="text-center fw-bold mb-4">Why Choose Us?</h2>
          <Row className="text-center">
            {[
              {
                title: "Domain Expertise",
                icon: "fa-laptop-code",
                desc:
                  "Expert teams across Cloud, SAP, Mobile, and Web Technologies.",
              },
              {
                title: "Agile Delivery",
                icon: "fa-rocket",
                desc:
                  "Quick turnaround with agile methodologies and transparent processes.",
              },
              {
                title: "Client-Centric Approach",
                icon: "fa-handshake",
                desc:
                  "Customized strategies that align with your business goals.",
              },
            ].map((item, idx) => (
              <Col md={4} className="mb-4" key={idx}>
                <i
                  className={`fa-solid ${item.icon} fs-1 mb-3 text-warning`}
                ></i>
                <h5 className="fw-bold">{item.title}</h5>
                <p>{item.desc}</p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer />

      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }

        ul {
          list-style: none;
          padding-left: 0;
        }
        ul li::before {
          margin-right: 10px;
          color: green;
        }
      `}</style>
    </div>
  );
};

export default AboutUsPage;
